import { CheckCircleIcon } from "@heroicons/react/24/outline";
import Button from "components/Button";
import Container from "components/Container";
import CTAHero from "features/home/components/CTAHero";
import React from "react";

export default function PricingPage() {
  return (
    <div>
      <CTAHero />
      <Container>
        <div className="grid grid-cols-1 gap-y-4 lg:grid-cols-8 py-12 border-t">
          <div className="pr-8 col-span-3">
            <span className="text-blue-500 mb-4 block">Join us</span>
            <h1 className="font-bold text-black text-4xl leading-10 mb-4">
              Simple, transparent pricing
            </h1>
            <p>
              Simple, transparent pricing that grows with you. Try any plan free
              for 30 days.
            </p>
          </div>
          <div className="grid gap-4 grid-cols-2 col-span-5">
            <div className="shadow-lg rounded-xl p-8">
              <div className="text-center">
                <span className="font-bold text-4xl text-black">$99</span>
                <p className="text-black">Monthly</p>
              </div>
              <ul className="flex gap-2 flex-col mt-4">
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>Browse all tenders and quotations</p>
                </li>
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>20 Request to participate</p>
                </li>
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>15 tenders / RFQs can submit</p>
                </li>
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>Your business profile</p>
                </li>
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>Basic chat and email support</p>
                </li>
              </ul>
              <Button className={"mt-4 w-full"} href="/supplier-register">
                Get Started
              </Button>
            </div>
            <div className="shadow-lg rounded-xl p-8">
              <div className="text-center">
                <span className="font-bold text-4xl text-black">$999</span>
                <p className="text-black">Yearly</p>
              </div>
              <ul className="flex gap-2 flex-col mt-4">
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>Release 10 tenders / quotations per month</p>
                </li>
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>Browse the supplier list</p>
                </li>
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>Up to 20 individual users</p>
                </li>
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>Escrow service</p>
                </li>
                <li className="flex gap-2">
                  <CheckCircleIcon className="size-6 text-emerald-500" />
                  <p>Basic chat and email support</p>
                </li>
              </ul>
              <Button className={"mt-4 w-full"} href="/supplier-register">
                Get Started
              </Button>
            </div>
          </div>
        </div>

        <div className="p-8 text-center">
          <h2 className="text-2xl text-black font-bold">Start your 30-day free trial free trial</h2>
          <p>Join over 4,000+ businessess already growing with Untitled.</p>
        </div>
      </Container>
    </div>
  );
}
